import moment from "moment";
import FormulaLayoutUI from "./FormulaLayoutUI";

import { multiply, sum, subtract } from "lodash";

const getMinValue = (...args) => {
  if (args.length === 0) {
    throw new Error("At least one number must be provided");
  }

  let smallest = Number(args[0]);

  for (let i = 1; i < args.length; i++) {
    if (Number(args[i]) < smallest || smallest === 0) {
      if (args[i] !== 0) {
        smallest = Number(args[i]);
      }
    }
  }
  return smallest;
};

const MillerTotalAmount = ({
  dispatch,
  net_weight,
  received_weight=0,
  returnBagQty=0,
  miller_bill_weight,
  unit,
  miller_advance,
  gst_charge,
  miller_brokerage,
  bri_brokerage,
  rate,
  tds_amount,
  miller_bill_amount,
  cashDiscount,
  arrivalDate,
  contract_type,
  module,
}) => {
  console.log(cashDiscount, "cashDiscount");
  
  const finalRate = Number(rate).toFixed(2)

  const nw = contract_type !== "FOR"
  ? Number(getMinValue(dispatch, net_weight,miller_bill_weight) - Number(returnBagQty || 0)).toFixed(3)
  : Number(getMinValue(dispatch, net_weight,received_weight, miller_bill_weight) - Number(returnBagQty || 0));
  const brokerage = Number(Number(miller_brokerage || 0).toFixed(2));
  // contract_type === "EX FACTORY" ? Number(miller_brokerage) : 0 ;
  // sum([bri_brokerage, miller_brokerage]);
  const middleVal = Number(
    subtract(
      Number(sum([multiply(nw, finalRate), gst_charge])),

      sum([miller_advance, tds_amount, brokerage])
    )
  ).toFixed(2)
  const finalVal = getMinValue(
    miller_bill_amount,
    middleVal
  ).toFixed(2);
  return (
    <FormulaLayoutUI>
      <div style={{ marginBottom: "18px" }}>
        <strong style={{ fontSize: "15px" }}>
         Miller Total Amount Formula
        </strong>
      </div>

      {/* Contract Rate */}
      <div style={{ fontSize: "13px", marginBottom: "8px" }}>
        Contract Rate: <strong>₹ {rate}</strong>
      </div>
      {returnBagQty > 0 && <div style={{ fontSize: "13px", marginBottom: "8px" }}>
        Return Bag Qty: <strong>{returnBagQty} {unit}</strong>
      </div>}

      {/* Final Net Weight */}
      <div
        style={{
          marginBottom: "12px",
          padding: "8px 10px",
          border: "1px solid #e0e0e0",
          borderRadius: "6px",
          fontSize: "13px",
        }}
      >
        <div>
          Final Net Weight = {contract_type !== "FOR"
          ? `min(Miller Bill Weight, Dispatch Weight, Net Weight(Dispatch)) ${returnBagQty > 0  ? `- Return Bag Qty` : ""}` 
          : `min(Miller Bill Weight, Dispatch Weight, Port Received Weight, Net Weight(Arrival)) ${returnBagQty > 0  ? `- Return Bag Qty` : ""}`}
        </div>

        <div style={{ marginTop: "4px", color: "#555" }}>
          {contract_type !== "FOR"
          ? `= min(${miller_bill_weight}, ${dispatch}, ${net_weight}) ${returnBagQty > 0  ? `- ${returnBagQty}` : ""}`
          : `= min(${miller_bill_weight}, ${dispatch}, ${received_weight}, ${net_weight}) ${returnBagQty > 0  ? `- ${returnBagQty}` : ""}`}
        </div>

        <div style={{ marginTop: "6px" }}>
          Final Net Weight:{" "}
          <strong>
            {Number(nw).toFixed(3)} {unit}
          </strong>
        </div>
      </div>

      {/* Final Amount */}
      <div
        style={{
          padding: "10px 12px",
          border: "1px solid #e0e0e0",
          borderRadius: "6px",
          fontSize: "13px",
        }}
      >
        <div>
          Total Amount = min( Miller Bill Amount, (Final Net Weight × Contract Rate) + GST − Advance − TDS − Miller Brokerage )
        </div>

        <div style={{ marginTop: "6px", color: "#555" }}>
          = min({miller_bill_amount}, (({nw} × {finalRate}) + {gst_charge} −{" "}
          {miller_advance} − {tds_amount} − {brokerage}))
        </div>
        <div style={{ marginTop: "6px", color: "#555" }}>
          = min({miller_bill_amount}, {middleVal})
        </div>

        <div
          style={{
            marginTop: "10px",
            fontSize: "15px",
            fontWeight: "600",
          }}
        >
          Total Amount: ₹ {Number(finalVal).toFixed(3)}
        </div>
      </div>
    </FormulaLayoutUI>
  );
};

export default MillerTotalAmount;
